"use client"
import React, { useState } from 'react';
import {Button} from "@/components/ui/button";
import Image from "next/image";
import LikeNormalIcon from "@/public/icons/normal-like-icon.svg";
import DisLikeNormalIcon from "@/public/icons/dislike-normal-icon.svg";
import {SingleProductEnum} from "@/constants/commerce-enum";
import LikeCommentServices from "@/http/api/profile/comments/LikeCommentServices";
import ReportCommentComponent from "@/components/ui/comments/report-comment-component";
import WizardFormAuth from "@/components/global/modals/wizard-auth-form-modal";
import {useAuthStore} from "@/store/auth/authStore";

const {likeComment} = new LikeCommentServices();

function VoteCommentComponent({likesCount: initialLikesCount, id, dislikesCount: initialDislikesCount}: {
    likesCount: number,
    id: number,
    dislikesCount: number
}) {
    const [likesCount, setLikesCount] = useState(initialLikesCount);
    const [dislikesCount, setDislikesCount] = useState(initialDislikesCount);
    const [userVote, setUserVote] = useState<"LIKED" | "DISLIKED" | null>(null);
    const {token} = useAuthStore((state) => state);

    const likeCommentHandler = async (state: "LIKED" | "DISLIKED") => {
        try {
            const payload = {
                state,
                comment_id: id
            }
            if (state === "LIKED") {
                if (userVote === "LIKED") {
                    setLikesCount(prev => prev - 1);
                    setUserVote(null);
                } else if (userVote === "DISLIKED") {
                    setLikesCount(prev => prev + 1);
                    setDislikesCount(prev => prev - 1);
                    setUserVote("LIKED");
                } else {
                    setLikesCount(prev => prev + 1);
                    setUserVote("LIKED");
                }
            } else {
                if (userVote === "DISLIKED") {
                    setDislikesCount(prev => prev - 1);
                    setUserVote(null);
                } else if (userVote === "LIKED") {
                    setLikesCount(prev => prev - 1);
                    setDislikesCount(prev => prev + 1);
                    setUserVote("DISLIKED");
                } else {
                    setDislikesCount(prev => prev + 1);
                    setUserVote("DISLIKED");
                }
            }

            await likeComment(payload);
        } catch (error) {
            console.error("Failed to update vote:", error);
            setLikesCount(initialLikesCount);
            setDislikesCount(initialDislikesCount);
            setUserVote(null);
        }
    }

    return (
        <div className="w-full flex flex-wrap border-y py-5 items-center justify-between">
            <div className="flex items-center gap-6 text-gray-400 font-medium text-sm justify-start">
                {SingleProductEnum.isThisCommentUsefull}
                <div className="flex flex-wrap items-center">
                    {token ? (
                        <Button
                            variant={"ghost"}
                            onClick={() => likeCommentHandler("LIKED")}
                            className={`flex items-end gap-1 hover:bg-transparent !text-base justify-start ${
                                userVote === "LIKED" ? "text-orange-primary" : "hover:text-orange-primary"
                            }`}
                        >
                            {likesCount.toLocaleString("fa")}
                            <Image
                                src={LikeNormalIcon}
                                width={24}
                                height={24}
                                alt={"LikeNormalIcon"}
                                className={userVote === "LIKED" ? "text-orange-primary" : ""}
                            />
                        </Button>
                    ) : (
                        <WizardFormAuth customButton={
                            <Button
                                variant={"ghost"}
                                type={"button"}
                                className='flex items-end gap-1 hover:bg-transparent !text-base justify-start hover:text-orange-primary'>
                                {likesCount.toLocaleString("fa")}
                                <Image src={LikeNormalIcon} width={24} height={24} alt={"LikeNormalIcon"}/>
                            </Button>
                        }/>
                    )}

                    {token ? (
                        <Button
                            variant={"ghost"}
                            onClick={() => likeCommentHandler("DISLIKED")}
                            className={`flex items-end gap-1 hover:bg-transparent !text-base justify-start ${
                                userVote === "DISLIKED" ? "text-orange-primary" : "hover:text-orange-primary"
                            }`}
                        >
                            {dislikesCount.toLocaleString("fa")}
                            <Image
                                src={DisLikeNormalIcon}
                                width={24}
                                height={24}
                                alt={"DisLikeNormalIcon"}
                                className={userVote === "DISLIKED" ? "text-orange-primary" : ""}
                            />
                        </Button>
                    ) : (
                        <WizardFormAuth customButton={
                            <Button
                                variant={"ghost"}
                                type={"button"}
                                className='flex items-end gap-1 hover:bg-transparent !text-base justify-start hover:text-orange-primary'>
                                {dislikesCount.toLocaleString("fa")}
                                <Image src={DisLikeNormalIcon} width={24} height={24} alt={"DisLikeNormalIcon"}/>
                            </Button>
                        }/>
                    )}
                </div>
            </div>
            <ReportCommentComponent id={id} agent={"desktop"}/>
        </div>
    );
}

export default VoteCommentComponent;